'use client';
import { useState } from 'react';
import { toast } from 'sonner';

export function useGoogleReviewsSync() {
  const [isLoading, setIsLoading] = useState(false);

  const syncReviews = async () => {
    // Ask user for password
    const secret = window.prompt('Enter Review Sync Password:');
    if (!secret) {
      toast.error('Review sync cancelled: no password entered');
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch('/api/gbp/reviews', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ secret }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        toast.error(`Reviews sync failed: ${data.error || res.statusText}`);
        return;
      }

      toast.success(`Fetched ${data.data?.reviews?.length || 0} reviews`);
    } catch (err: any) {
      console.error(err);
      toast.error(`Error syncing reviews: ${err.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return { syncReviews, isLoading };
}
